import { enUs } from './en-US'

export const tuqqiTalkResources = {
    "en-US": enUs,
}